var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2283 2.48145C16.1727 2.48145 19.3628 5.61145 19.3628 9.48145C19.3628 14.7314 12.2283 22.4814 12.2283 22.4814C12.2283 22.4814 5.09375 14.7314 5.09375 9.48145C5.09375 5.61145 8.28391 2.48145 12.2283 2.48145ZM7.13281 9.48145C7.13281 12.3314 10.1089 16.6914 12.2289 19.3614C14.3897 16.6714 17.325 12.3614 17.325 9.48145C17.325 6.72145 15.042 4.48145 12.2289 4.48145C9.41586 4.48145 7.13281 6.72145 7.13281 9.48145ZM12.2277 11.9814C10.8205 11.9814 9.67969 10.8622 9.67969 9.48145C9.67969 8.10073 10.8205 6.98145 12.2277 6.98145C13.635 6.98145 14.7758 8.10073 14.7758 9.48145C14.7758 10.8622 13.635 11.9814 12.2277 11.9814Z",
    fill: "#CF9F1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOn);
export default __webpack_public_path__ + "static/media/location_on.decc628363c84cdd876b5e26beaf72b2.svg";
export { ForwardRef as ReactComponent };